if (!customElements.get('gok-recipient-tax-id')) {
  class GokRecipientTaxId extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="attributes[Recipient Tax ID]"]');
      this.status = this.querySelector('[data-tax-id-status]');
      this.country = this.dataset.country;

      if (!this.input || this.abortController) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.input.addEventListener('change', () => this.save(), { signal });
      this.input.addEventListener('blur', () => this.save(), { signal });
      this.input.addEventListener('input', () => this.clearError(), { signal });

      const cartForm = document.getElementById('cart-form');
      cartForm?.addEventListener('submit', (event) => this.validate(event), {
        capture: true,
        signal,
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    validate(event) {
      this.input.value = this.input.value.trim();

      if (this.input.checkValidity()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.input.reportValidity();
      this.input.focus();
    }

    clearError() {
      if (!this.status || this.status.dataset.state !== 'error') return;
      this.status.textContent = '';
      delete this.status.dataset.state;
    }

    async save() {
      const value = this.input.value.trim();
      this.input.value = value;

      if (!value || !this.input.checkValidity()) return;

      this.setStatus('Saving…');

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'Recipient Tax ID': value,
              'Recipient Tax ID country': this.country,
            },
          }),
        });

        if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);

        this.setStatus('Saved with your order.');
      } catch (_error) {
        this.setStatus('Could not save automatically. Please try again before checkout.', 'error');
      }
    }

    setStatus(message, state = '') {
      if (!this.status) return;
      this.status.textContent = message;
      if (state) this.status.dataset.state = state;
      else delete this.status.dataset.state;
    }
  }

  customElements.define('gok-recipient-tax-id', GokRecipientTaxId);
}
